// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Ng94","inner":"Form_inner__2nzP5","range":"Form_range__1D8Jv","name":"Form_name__3mL7W","actions":"Form_actions__11Cz0"};